/**
 * Helper
 */
var helper = require('../../helper'),
        dataTables_buttons = [

            {
                extend: 'csv',
                text: 'Export as CSV',
                exportOptions: {
                    columns: [0, 1]
                },
                className: 'btn btn-default'
            },
            {
                extend: 'pdf',
                text: 'Export as PDF',
                exportOptions: {
                    columns: [0, 1]
                },
                className: 'btn btn-default',
                orientation: 'landscape'
            },
            {
                extend: 'colvis',
                className: 'btn btn-default'
                //     columns: ':gt(0)'
            }


        ];


$(function() {
    var $datatable = $('#datatable-inspection-types'),
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/inspection-types",
            "method": 'POST',
            "data": function ( d ) {

            }
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
            {data: 'name', name: 'name'},
	        {data: 'colorSpan', name: 'color'},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action"}
        ],
        "initComplete": function(settings, json) {
            // init callback
        }
    });

});
